(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["zoter-inbox-nudge"] && !Shopify.designMode) return;
  try {
    (() => {
    const nudge = document.querySelector('[data-zoter-inbox-nudge]');
    if (!nudge) return;

    const closeButton = nudge.querySelector('[data-zoter-inbox-close]');
    const openButton = nudge.querySelector('[data-zoter-inbox-open]');
    const manualMessage = nudge.querySelector('[data-zoter-inbox-manual]');
    let autoCloseTimer;
    let revealTimer;
    let chatEngaged = false;
    const collectRoots = (rootNode, roots = []) => {
      if (!rootNode?.querySelectorAll) return roots;
      roots.push(rootNode);

      rootNode.querySelectorAll('*').forEach((element) => {
        if (element.shadowRoot) collectRoots(element.shadowRoot, roots);
      });

      return roots;
    };

    const popupIsVisible = () => {
      return collectRoots(document).some((rootNode) => {
        const candidates = rootNode.querySelectorAll('dialog[open], [role="dialog"]');

        return Array.from(candidates).some((element) => {
          if (element.closest?.('[data-zoter-inbox-nudge]')) return false;
          const styles = window.getComputedStyle(element);
          const bounds = element.getBoundingClientRect();
          return styles.display !== 'none' && styles.visibility !== 'hidden' && bounds.width > 100 && bounds.height > 100;
        });
      });
    };

    const hide = () => {
      window.clearTimeout(autoCloseTimer);
      nudge.classList.remove('is-visible');
      window.setTimeout(() => {
        nudge.hidden = true;
      }, 220);
    };

    const reveal = () => {
      if (chatEngaged || popupIsVisible()) return;
      nudge.hidden = false;
      window.requestAnimationFrame(() => nudge.classList.add('is-visible'));
      autoCloseTimer = window.setTimeout(hide, 8000);
    };

    const findChatButton = (root) => {
      const selectors = [
        'button[aria-label*="chat" i]',
        'button[aria-label*="message" i]',
        'button[title*="chat" i]',
        '[role="button"][aria-label*="chat" i]'
      ];
      for (const selector of selectors) {
        const match = root.querySelector(selector);
        if (match && !match.closest('[data-zoter-inbox-nudge]')) return match;
      }
      for (const element of root.querySelectorAll('*')) {
        if (element.shadowRoot) {
          const match = findChatButton(element.shadowRoot);
          if (match) return match;
        }
      }
      return null;
    };

    revealTimer = window.setTimeout(reveal, 6500);

    document.addEventListener(
      'click',
      (event) => {
        const labels = event.composedPath().map((element) => element?.getAttribute?.('aria-label')).filter(Boolean);

        if (labels.includes('Chat')) {
          chatEngaged = true;
          window.clearTimeout(revealTimer);
          hide();
        }
      },
      true
    );

    window.setInterval(() => {
      if (!nudge.hidden && popupIsVisible()) hide();
    }, 350);

    closeButton?.addEventListener('click', hide);
    openButton?.addEventListener('click', () => {
      window.clearTimeout(autoCloseTimer);
      const chatButton = findChatButton(document);
      if (chatButton) {
        chatButton.click();
        hide();
        return;
      }
      manualMessage.hidden = false;
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
